import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import {  ForgotPasswordModel } from 'src/app/models/login/forgotPassword';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordModel: ForgotPasswordModel = new ForgotPasswordModel();
  Loader: boolean = false;
  showMessageLoader: boolean = true;
  formHideLoader: boolean = false;
  showFormLoader: boolean = true;

  constructor(private localstorage:LocalstorageService, private alertify:AlertifyService, private router:Router, private _loginService: LoginService) 
  {
  }
  ngOnInit() {
  }

  onSubmit() {
    this.Loader = true;
    this.showMessageLoader = false;
    this.formHideLoader = false;
    this.showFormLoader = true;
    this._loginService.forgotPassword(this.forgotPasswordModel).subscribe(res => {
      var responseData = JSON.parse(res._body);
        if (responseData.isSuccess)
          {
            this.localstorage.setToken(responseData.responseData.token);
            this.localstorage.setname(responseData.responseData.email);    
            this.Loader = false;
            this.showMessageLoader = false;
            this.formHideLoader = true;
            this.showFormLoader = false;
          }
          else 
          {
            this.alertify.error(responseData.responseMessage);
            this.Loader = false;
          }
      },
    )
  }   
}
